(function () {
  var config = window.CBDMD_TN_GEO;
  if (!config || !config.enabled) return;

  var cacheMin = parseInt(config.geoCacheMinutes, 10);
  if (isNaN(cacheMin) || cacheMin < 0) {
    cacheMin = 1440;
  }
  var STORAGE_TTL_MS = cacheMin * 60 * 1000;
  var useGeoCache = STORAGE_TTL_MS > 0;
  var POPUP_STORAGE_KEY = 'cbdmd_tn_popup_shown_v1';
  var states = Array.isArray(config.states) && config.states.length
    ? config.states
    : [{ code: 'TN', name: 'Tennessee' }];

  var modal = document.getElementById('TennesseeStateBlocker');
  if (!modal) return;

  function showModal() {
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('tennessee-state-blocker-open');
    document.body.classList.add('tennessee-state-blocker-open');
  }

  function hideModal() {
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('tennessee-state-blocker-open');
    document.body.classList.remove('tennessee-state-blocker-open');
  }

  function matchState(regionCode, countryCode) {
    if (String(countryCode || '').toUpperCase() !== 'US') return null;
    var value = String(regionCode || '').trim().toUpperCase();
    if (!value) return null;

    for (var i = 0; i < states.length; i++) {
      var state = states[i];
      var code = String(state.code || '').trim().toUpperCase();
      var name = String(state.name || '').trim().toUpperCase();
      if (value === code || value === name) return state;
    }

    return null;
  }

  function isWithinTtl(ts) {
    return (Date.now() - ts) <= STORAGE_TTL_MS;
  }

  function hasSeenPopupRecently() {
    if (!useGeoCache) {
      return false;
    }
    try {
      var raw = localStorage.getItem(POPUP_STORAGE_KEY);
      if (!raw) return false;

      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.ts) return false;

      if (!isWithinTtl(parsed.ts)) {
        localStorage.removeItem(POPUP_STORAGE_KEY);
        return false;
      }

      return true;
    } catch (e) {
      return false;
    }
  }

  function markPopupShown() {
    if (!useGeoCache) {
      return;
    }
    try {
      localStorage.setItem(POPUP_STORAGE_KEY, JSON.stringify({
        ts: Date.now()
      }));
    } catch (e) {}
  }

  function fetchGeo() {
    if (!window.CBDMD_GEO) {
      return Promise.reject(new Error('Geo lookup unavailable'));
    }
    return window.CBDMD_GEO.lookup(config);
  }

  function bindModalClose() {
    modal.addEventListener('click', function (e) {
      if (e.target.matches('[data-tn-close]')) {
        hideModal();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) {
        hideModal();
      }
    });
  }

  function maybeShowNotice() {
    if (hasSeenPopupRecently()) {
      return;
    }

    showModal();
    markPopupShown();
  }

  async function init() {
    bindModalClose();

    try {
      var geo = await fetchGeo();
      var countryCode = geo && (geo.country_code || geo.country);
      var regionCode = geo && (geo.region_code || geo.region);

      var state = matchState(regionCode, countryCode);
      if (state) {
        maybeShowNotice();
      }
    } catch (err) {
      console.warn('[TennesseeStateBlocker]', err);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
